import store from '../store';

export const clearError = (actions) => {
  for (let action of actions) {
    store.dispatch({ type: action + '_FAILURE', data: undefined });
  }
};
